import React from 'react'
import {Box, Divider, IconButton, Typography, Grid} from '@mui/material'
import {
    AutocompleteInput,
    DateTimeInput,
    DeleteButton,
    Edit,
    NumberInput,
    ReferenceArrayInput,
    ReferenceInput,
    SaveButton,
    SelectInput,
    SimpleForm,
    TextInput,
    Toolbar,
    useGetOne,
    useNotify,
} from 'react-admin'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import {useNavigate} from 'react-router-dom'

import {PAYMENT} from "../constant";
import {MainCategorySelector, TypeSelector} from "./EntryCreateForm";
import {useEntryContext} from "./EntryContext";
import {fetchWithToken} from "../fetchWithToken";

const CustomToolbar = props => (
    <Toolbar {...props} >
        <Box display="flex" justifyContent="space-between" width="100%">
            <SaveButton
                label="保存"
                alwaysEnable
                // Add your custom props here
            />
            <DeleteButton
                label="删除"
                // Add your custom props here
            />
        </Box>
    </Toolbar>
);

export const EntryEdit = ({id}) => {
    const {data} = useGetOne('entry', {id: id}, {enabled: !!id})
    const navigate = useNavigate()
    const {refresh} = useEntryContext()
    const notify = useNotify()

    const handleSave = (values) => {
        const {parent, children, id, ...rest} = values
        console.log('transform', {
            ...rest,
            content: rest.content || '',
            category: typeof rest.category === 'object' ? rest.category.id : rest.category,
        })
        fetchWithToken(`/api/entry/${id}/`, {
            ...rest,
            category: typeof rest.category === 'object' ? rest.category.id : rest.category,
        }, 'PATCH').then(({data}) => {
            // Do something with the response data
            console.log('data', data)
            notify('更新成功')
            navigate('/entry')
            refresh()
        }).catch((error) => {
            // Do something with the error
            console.log('error', error)
            notify('更新失败')
        })
    };

    if (!data) return null
    return (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 1,
            }}>
                <Typography variant="h5">
                    账单详情-{id}
                </Typography>
                <IconButton onClick={() => navigate('/entry')}>
                    <HighlightOffIcon fontSize="large" color="primary"/>
                </IconButton>
            </Box>

            <Divider/>

            <Edit resource="entry" id={id} sx={{ p: 1 }}>
                <SimpleForm
                    toolbar={<CustomToolbar/>}
                    redirect="list"
                    onSubmit={handleSave}
                    sx={{
                        '& .RaFormInput-input': { mb: 0.5 },
                        '& .MuiFormControl-root': { mb: 0.5 },
                    }}
                    defaultValues={
                        {
                            title: data.title,
                            content: data.content,
                            amount: data.amount,
                            datetime: data.datetime,
                            payment: data.payment,
                            level: data.level,
                            category: data.category.id,
                        }
                    }
                >
                    <Grid container spacing={0.5}>
                        <Grid item xs={12}>
                            <TextInput source="title" label="标题" resettable isRequired fullWidth/>
                        </Grid>

                        <Grid item xs={12}>
                            <TextInput source="content" label="详情" fullWidth multiline rows={2}/>
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <NumberInput source="amount" label="金额" isRequired sx={{ width: '200px' }}/>
                                <SelectInput source="payment" label="支付方式" required choices={PAYMENT} sx={{ minWidth: '140px', flex: 1 }}/>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <DateTimeInput source="datetime" label="时间" isRequired fullWidth/>
                        </Grid>

                        {data.parent && (
                            <Grid item xs={12}>
                                <ReferenceInput source="parent" reference="entry" fullWidth>
                                    <AutocompleteInput source="id" label="上级账单" disabled={true}/>
                                </ReferenceInput>
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>账单类别</Typography>
                            <MainCategorySelector curCategory={data.category}/>
                        </Grid>

                        <Grid item xs={12}>
                            <ReferenceArrayInput source="label" reference="label" label="标签" fullWidth/>
                        </Grid>

                        <Grid item xs={12}>
                            <TypeSelector fullWidth/>
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Edit>
        </>
    )
}
